module.exports = __webpack_public_path__ + "static/media/RA24.f57d1b20.gif";